<template>
  <div>    
    <ul class="fixed-max-width-650" style="flex-wrap: wrap;">
      <li class="mb-4">
        <vx-card ref="chat_card" class="mentorship-item__black-gradient vs-con-loading__container" @click="$router.push({ name : $route.name == 'Gen2Mentoring' ? 'Gen2Q&A' : 'Q&A', query: { module: selectedMentorModuleId, n: $route.query.n } })">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="vx-row">
                <div class="vx-col self-center"  style="width: 30% !important;">
                  <svg xmlns="http://www.w3.org/2000/svg" style="color: white" width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                </div>
                <div class="vx-col self-center"  style="width: 70% !important;">
                  <p class="uppercase" :class="{'gradient-text_header__50': windowWidth < 570 || isMobile(), 'gradient-text_header': windowWidth >= 570 && !isMobile()}">Q&A</p>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </li>

      <li class="mb-4">
        <vx-card ref="chat_card" class="mentorship-item__school-gradient vs-con-loading__container" @click="$router.push({ name : $route.name == 'Gen2Mentoring' ? 'Gen2Media' : 'Media', query: { mentoring: true, module: selectedMentorModuleId, n: $route.query.n } })">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="vx-row">
                <div class="vx-col self-center"  style="width: 30% !important;">
                  <svg xmlns="http://www.w3.org/2000/svg" style="color: white" width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-youtube"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon></svg>
                </div>
                <div class="vx-col self-center"  style="width: 70% !important;">
                  <p class="uppercase" :class="{'gradient-text_header__40': windowWidth < 570 || isMobile(), 'gradient-text_header': windowWidth >= 570 && !isMobile()}">Media</p>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </li>

      <li class="mb-4" v-if="false">
        <vx-card ref="chat_card" class="mentorship-item__black-gradient vs-con-loading__container" @click="$router.push({ name : $route.name == 'Gen2Mentoring' ? 'Gen2MentorChat' : 'Chat', query: { mentoring: true, module: selectedMentorModuleId, n: $route.query.n } })">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="vx-row">
                <div class="vx-col self-center"  style="width: 30% !important;">
                  <svg xmlns="http://www.w3.org/2000/svg" style="color: white" width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-message-circle"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
                </div>
                <div class="vx-col self-center"  style="width: 70% !important;">
                  <p class="uppercase" :class="{'gradient-text_header__47': windowWidth < 570 || isMobile(), 'gradient-text_header': windowWidth >= 570 && !isMobile()}">Chat</p>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </li>

      <li class="mb-4">
        <vx-card ref="chat_card" class="mentorship-item__school-gradient vs-con-loading__container" @click="$router.push({ name : $route.name == 'Gen2Mentoring' ? 'Gen2CallBack' : 'CallBack', query: { module: selectedMentorModuleId, n: $route.query.n } })">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="vx-row">
                <div class="vx-col self-center" style="width: 30% !important;">
                <svg xmlns="http://www.w3.org/2000/svg" style="color: white" width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-phone-call"><path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                </div>
                <div class="vx-colself-center" style="width: 70% !important;">
                  <p class="uppercase" :class="{'gradient-text_header__40': windowWidth < 570 || isMobile(), 'gradient-text_header': windowWidth >= 570 && !isMobile()}">Call Back</p>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </li>
      
    </ul>
  </div>
</template>

<script>
import * as signalR from "@aspnet/signalr";
export default {
  components: {
    
  },
  data() {
    return {
      selectedMentorModuleId: null,
      connection: null,
      groupId: null,
      windowWidth: window.innerWidth
    };
  },
  watch: {
    
  },
  computed: {
    
  },
  methods: {
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
    },
  },
  mounted() {
    var self = this;

    self.selectedMentorModuleId = self.$route.query.module;
    self.$nextTick(() => {
      window.addEventListener("resize", self.handleWindowResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", self.handleWindowResize);
  }
};
</script>